// @ts-check

import { checkObject } from 'libs/types/checkTypes';
import convertAddresses from './convertAddresses';
import USER from '../ts/profileEditorEnum';

/**
 * @function convertEditorUser
 * @param {ProfileViewerState} viewerState
 * @returns {EditorUserType}
 */
function convertEditorUser(viewerState) {
	checkObject(viewerState);

	const { user, userInfo, languages, contactTypes, roleGroups, companies } = viewerState;

	const newUser = {
		[USER.ID]: user.id,
		[USER.CONTACT_ID]: user.contactId,
		[USER.V_FILE_ID]: user.vFileId,
		[USER.IS_ENABLED]: user.isEnabled,
		[USER.FIRST_NAME]: user.firstName,
		[USER.LAST_NAME]: user.lastName,
		[USER.USERNAME]: user.username,
		[USER.PHONE_WORK]: user.phoneWork,
		[USER.PHONE_WORK_DIAL_CODE]: user.phoneWorkDialCode,
		[USER.PHONE_WORK_COUNTRY_CODE]: user.phoneWorkCountryCode,
		[USER.PHONE_WORK_EXT]: user.phoneWorkExt,
		[USER.PHONE_MOBILE]: user.phoneMobile,
		[USER.PHONE_MOBILE_DIAL_CODE]: user.phoneMobileDialCode,
		[USER.PHONE_MOBILE_COUNTRY_CODE]: user.phoneMobileCountryCode,
		[USER.PHONE_MOBILE_EXT]: user.phoneMobileExt,
		[USER.PHONE_OTHER]: user.phoneOther,
		[USER.PHONE_OTHER_DIAL_CODE]: user.phoneOtherDialCode,
		[USER.PHONE_OTHER_COUNTRY_CODE]: user.phoneOtherCountryCode,
		[USER.PHONE_OTHER_EXT]: user.phoneOtherExt,
		[USER.EMAIL_WORK]: user.emailWork,
		[USER.EMAIL_PERSONAL]: user.emailPersonal,
		[USER.EMAIL_OTHER]: user.emailOther,
		[USER.LANGUAGES]: languages.filter((language) =>
			user.languageIds.some((id) => language.id === id),
		),
		[USER.CONTACT_TYPES]: contactTypes.filter((contactType) =>
			user.contactTypes.some((id) => contactType.Id === id),
		),
		[USER.ROLE_GROUPS]: roleGroups.filter((roleGroup) =>
			user.roles.some((id) => roleGroup.id === id),
		),
		[USER.COMPANIES]: companies.filter((company) => user.companies.some((id) => company.Id === id)),
		[USER.ACCESSIBLE]: companies.find((company) => company.Id === user.masterCustId),
		[USER.ADDRESSES]: convertAddresses(user.addresses, user.addressIds),
		[USER.NOTES]: user.note,
		[USER.IMAGE]: userInfo.image,
		[USER.PASSWORD]: '',
		[USER.CONFIRM_PASSWORD]: '',
		[USER.FILE]: null,
	};

	return newUser;
}

export default convertEditorUser;
